export const useAppSnack = () => {
  type SnackbarColor = 'success' | 'error' | 'warning' | 'info';

  interface SnackProps {
    open: boolean;
    message: string;
    color: SnackbarColor;
    location?: string;
    timeout?: number;
    closeOnContentClick?: boolean;
  }

  const snack = useState('snack', () => {
    return <SnackProps>{
      open: false,
      message: '',
      color: 'success',
      location: 'bottom right',
    };
  });

  const displaySnack = (
    msg: string,
    color: SnackbarColor = 'success',
    location?: string,
    timeout?: number,
    closeOnContentClick?: boolean,
  ) => {
    snack.value.message = msg;
    snack.value.color = color;
    snack.value.location = location ?? 'bottom right';
    snack.value.timeout = timeout;
    snack.value.closeOnContentClick = closeOnContentClick;

    snack.value.open = true;
  };

  return {
    snack,
    displaySnack,
  };
};
